import { call, put, takeEvery } from 'redux-saga/effects';
import { GET_USER_PHONES_REQUEST } from '../../constants/user_phones.constants';
import { getUserProfilePhones } from '../../../requests/user_phones_requests/get_user_phones_request';
import { getUserPhonesRequestSuccess, getUserPhonesRequestFailure } from '../../actions/user_phones_actions/get_user_phones.actions';
import { message_error } from '../../../../../../components/Message';

function* getUserPhoneRequest({ _id }) {
    const { result, options, error } = yield call(getUserProfilePhones, _id);
    if (result) {
        yield put(getUserPhonesRequestSuccess(options.person.phones));
    } else {
        yield put(getUserPhonesRequestFailure(error));
        message_error(error);
    }
}

export default function* getUserPhoneSaga() {
    yield takeEvery(GET_USER_PHONES_REQUEST, getUserPhoneRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_phones_sagas/get_user_phones.saga.js